export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/custom_made_booth.53cbee3.svg";